import styled from 'styled-components/native';

import LoginFormButton from 'components/LoginFormButton';

export default styled(LoginFormButton)`
  margin: 39px 0 0;
  width: 216px;
  height: 44px;
`;
